import React, { useContext, useEffect, useState } from "react";
import { format, addDays, isSunday } from "date-fns";
import { GlobalContext } from "../../Context/GlobalState";
import Select from "react-select";
import swal from "sweetalert";
import { FaHome } from "react-icons/fa";
import { Button, Col, Form, Row, Modal } from "react-bootstrap";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { BulkAttendanceAdmin } from "../Modal";
import halfday from "../../assets/images/half-time.svg";
import { MdWatchOff } from "react-icons/md";
import { Link } from "react-router-dom";

import gifIcon from "../../assets/images/newgif.gif";
const AttandancecalendraAdmin = () => {
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const { password, username } = billpunchbasicauth;
  const [showcheckmodal, setshowcheckmodal] = useState(false);
  const [dates, setDates] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [firmHolidays, setFirmHolidays] = useState({ firmId: null, dates: {} });
  const firmId = user?.firm_id;
  const holidayDates = firmHolidays.firmId === firmId ? firmHolidays.dates : {};

  useEffect(() => {
    if (!firmId) return;
    const controller = new AbortController();
    const getHolidays = async () => {
      try {
        const res = await fetch(
          `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmHoliday`,
          {
            method: "POST",
            headers: {
              Authorization: `Basic ${btoa(`${username}:${password}`)}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ firmid: firmId }),
            signal: controller.signal,
          }
        );
        if (!res.ok) throw new Error("Unable to fetch firm holidays");
        const data = await res.json();
        const mappedHolidays = {};
        if (data.status === "0" && Array.isArray(data.data)) {
          data.data.forEach((holiday) => {
            const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(holiday.datee?.trim());
            if (!match) return;
            const [, day, month, year] = match;
            const date = new Date(Number(year), Number(month) - 1, Number(day));
            if (date.getFullYear() !== Number(year) || date.getMonth() !== Number(month) - 1 || date.getDate() !== Number(day)) return;
            const key = format(date, "yyyy-MM-dd");
            const name = holiday.holiday || "Firm holiday";
            mappedHolidays[key] = mappedHolidays[key] ? `${mappedHolidays[key]}, ${name}` : name;
          });
        }
        if (!controller.signal.aborted) {
          setFirmHolidays({ firmId, dates: mappedHolidays });
        }
      } catch (error) {
        if (error.name !== "AbortError") console.error("Error fetching firm holidays:", error);
      }
    };
    getHolidays();
    return () => controller.abort();
  }, [firmId, username, password]);

  const currentYear = new Date().getFullYear();
  const [years, setYears] = useState(currentYear.toString());
  const currentMonth = new Date().getMonth() + 1;
  const [months, setMonths] = useState(currentMonth.toString());
  const [department, setDepartment] = useState("");

  const selectedMonthHolidays = Object.entries(holidayDates)
    .filter(([date]) => date.startsWith(`${years}-${String(months).padStart(2, "0")}-`))
    .sort(([first], [second]) => first.localeCompare(second));

  const isSecondSaturday = (date) =>
    date.getDay() === 6 && date.getDate() >= 8 && date.getDate() <= 14;

  const generateMonthDates = (year, month) => {
    const startDate = new Date(year, month - 1, 1);
    const endDate = new Date(year, month, 0);
    const dates = [];
    let currentDate = startDate;

    while (currentDate <= endDate) {
      dates.push(currentDate);
      currentDate = addDays(currentDate, 1);
    }

    return dates;
  };

  useEffect(() => {
    const year = parseInt(years);
    const month = parseInt(months);
    const generatedDates = generateMonthDates(year, month);
    setDates(generatedDates);
  }, [years, months]);

  const generateMonthHeaders = (year, month) => {
    const dates = generateMonthDates(year, month);

    const date = new Date(years, months - 1, 1);
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const datess = dates.length;

    return dates.map((date) => (
      <th
        key={format(date, "yyyy-MM-dd")}
        style={{
          position: "sticky",
          top: 0,
          background: "#48A6A7",
          zIndex: 2,
          textAlign: "center",
          fontSize: ".8rem",
          fontWeight: "400",
          color: "#fff",
          padding: ".7rem",
        }}
      >
        {format(date, "dd")}
      </th>
    ));
  };

  useEffect(() => {
    const updatedHeaders = generateMonthHeaders(
      parseInt(years),
      parseInt(months)
    );
    setTableHeaders(updatedHeaders);
  }, [months, years]);

  const [employees, setEmployees] = useState([]);
  const [attendance, setAttendance] = useState({});
  const [attendanceChanges, setAttendanceChanges] = useState([]);

  const handleCheckboxChange = (employeeId, day, isChecked) => {
    const updatedChanges = [...attendanceChanges];
    const updatedEmployees = [...employees];
    const dateStr = format(new Date(day), "yyyy-MM-dd");

    const changeIndex = updatedChanges.findIndex(
      (change) => change.id === employeeId && change.attendance_date === dateStr
    );

    if (isChecked) {
      if (changeIndex === -1) {
        updatedChanges.push({
          id: employeeId,
          firmid: user.firm_id,
          attendance_date: dateStr,
          attendance_status: "Y",
          type: "Attendance",
        });
      } else {
        updatedChanges[changeIndex].attendance_status = "Y";
      }
    } else {
      if (changeIndex === -1) {
        updatedChanges.push({
          id: employeeId,
          firmid: user.firm_id,
          attendance_date: dateStr,
          attendance_status: "N",
          type: "Attendance",
        });
      } else {
        updatedChanges[changeIndex].attendance_status = "N";
      }
    }

    const employeeIndex = updatedEmployees.findIndex(
      (employee) => employee.employee_code === employeeId
    );
    if (employeeIndex !== -1) {
      const dayIndex = updatedEmployees[employeeIndex].data.findIndex(
        (entry) =>
          format(new Date(entry.attendance_date), "yyyy-MM-dd") === dateStr
      );
      if (dayIndex !== -1) {
        updatedEmployees[employeeIndex].data[dayIndex].attendance_status =
          isChecked ? "Y" : "N";
      } else {
        updatedEmployees[employeeIndex].data.push({
          attendance_date: dateStr,
          attendance_status: isChecked ? "Y" : "N",
        });
      }
    }

    setAttendanceChanges(updatedChanges);
    setEmployees(updatedEmployees);
  };

  const handleMarkAttendance = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestBody = JSON.stringify({ requests: attendanceChanges });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: requestBody,
        redirect: "follow",
      };

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/MarkAttendance`,
        requestOptions
      );

      const data = await response.json();
      if (data.status === "0") {
        getAttandancedata();
        setAttendanceChanges([]);
      } else {
        swal("Error marking attendance:", data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      swal("Error marking attendance:", error);
      setTransactionLoaderState(false);
    }
  };
  const MarkAttendance = async () => {
    if (!validateForm()) {
      swal("Error", "Please fill in all fields.", "error");
      return;
    }

    const { selectedEmployee, selectedDate, inTime, outTime, status } =
      formData;
    const empid = selectedEmployee.value;
    const firmid = selectedEmployee.firmId;

    const dateObj = new Date(selectedDate);
    const attendanceDate = dateObj.toISOString().split("T")[0];

    const requestBody = {
      requests: [
        {
          id: empid,
          firmid,
          attendance_date: attendanceDate,
          attendance_status: status.value,
          type: "Attendance",
          in_time: inTime,
          out_time: outTime,
        },
      ],
    };

    try {
      setTransactionLoaderState(true);
      const base64Credentials = btoa(`${username}:${password}`);

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/MarkAttendance`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();
      if (data.status === "0") {
        getAttandancedata();
        setAttendanceChanges([]);
        setFormData({
          selectedEmployee: null,
          selectedDate: null,
          inTime: "",
          outTime: "",
          status: null,
        });
      } else {
        swal("Error marking attendance:", data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      swal("Error marking attendance:", error);
      setTransactionLoaderState(false);
    }
  };
  const getAttandancedata = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        id: user.firm_id,
        month: months,
        year: years,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetMarkAttendance`,
        requestOptions
      );

      const data = await res.json();
      if (data.status === "0" || data.status == "1") {
        const updatedAttendance = {};

        const employeesList = data.data;
        const employeesListNew = [];
        const dates = generateMonthDates(years, months);
        const datess = dates.length;
        console.log(datess + "meeeee");

        employeesList.forEach((ee) => {
          const datesNew = [];
          for (let i = 1; i <= datess; i++) {
            let found2 = null;
            ee.data.map((entry) => {
              if (new Date(entry.attendance_date).getDate() == i) {
                found2 = entry;
              }
            });
            if (found2) {
              datesNew.push(found2);
            } else {
              let d2 = new Date();
              d2.setDate(i + 1);
              d2.setMonth(months - 1);
              datesNew.push({
                attendance_date: d2,
                attendance_status: "N",
                month: months,
                year: years,
              });
            }
          }
          //  console.log(datesNew);
          ee.data = datesNew;
          // console.log(ee);
          employeesListNew.push(ee);
        });

        // console.log(employeesListNew);
        setAttendance(updatedAttendance);
        setEmployees(data.data);
      } else {
        swal("Error fetching attendance data:", data.msg);
      }

      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
  };
  const getDepartmentList = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({ firmid: user.firm_id });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployeeDepartment`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setDepartmentData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
    }
  };
  const openModal = () => {
    setshowcheckmodal(true);
  };

  const closeModal = () => {
    setshowcheckmodal(false);
  };

  useEffect(() => {
    getDepartmentList();
    getAttandancedata();
  }, [months]);

  useEffect(() => {
    if (employees.length > 0) {
    }
  }, [employees]);
  // console.log(employees);

  useEffect(() => {
    if (department !== "") {
      const filtered = employees.filter(
        (employee) => employee.employee_department === department
      );
      setFilteredEmployees(filtered);
    } else {
      setFilteredEmployees(employees);
    }
  }, [department, employees]);

  const { accessData } = useContext(GlobalContext);
  // useEffect(() => {
  //   console.log("Access Data:", accessData);
  // }, [accessData]);

  //
  const [empdata, setempdata] = useState([]);
  const [formData, setFormData] = useState({
    selectedEmployee: null,
    selectedDate: null,
    inTime: "",
    outTime: "",
    status: null,
  });
  const getEmployeeList = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmId: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setempdata(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    getEmployeeList();
  }, []);
  const handleInputChange = (field, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value,
    }));
  };
  const employeeOptions = empdata.map((emp) => ({
    value: emp.empid,
    label: `${emp.firstname} ${emp.lastname}`,
    firmId: emp.firm_id,
  }));

  const statusOptions = [
    { value: "Y", label: "Present" },
    { value: "N", label: "Absent" },
  ];
  const validateForm = () => {
    const { selectedEmployee, selectedDate } = formData;
    return selectedEmployee && selectedDate;
  };
  const convertTo12HourFormat = (time24) => {
    if (!time24) return "";
    const [hour, minute] = time24.split(":");
    const h = parseInt(hour);
    const ampm = h >= 12 ? "PM" : "AM";
    const hour12 = h % 12 || 12;
    return `${hour12}:${minute} ${ampm}`;
  };

  const handleMarkAttendanceType = async (type) => {
    if (!validateForm()) {
      swal("Error", "Please fill in all fields.", "error");
      return;
    }

    const { selectedEmployee, selectedDate, inTime, outTime } = formData;

    const empid = selectedEmployee.value;
    const firmid = selectedEmployee.firmId;

    const dateObj = new Date(selectedDate);
    const year = String(dateObj.getFullYear());
    const month = String(dateObj.getMonth() + 1);
    const date = String(dateObj.getDate());
    const formattedDate = `${year}-${month}-${date}`;

    const requestBody = {
      empid: String(empid),
      date: formattedDate,
      month: month,
      year: year,
      firmid: String(firmid),
      in_time: inTime,   
      out_time: outTime,
      // in_time: convertTo12HourFormat(inTime),
      // out_time: convertTo12HourFormat(outTime),
      type: String(type),
    };

    try {
      setTransactionLoaderState(true);
      const base64Credentials = btoa(`${username}:${password}`);

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/MakHalfDay`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();

      if (
        responseData.status === "0" &&
        responseData.result[0].result === "Y"
      ) {
        swal("Success", responseData.result[0].message, "success");
        getAttandancedata();
        setFormData({
          selectedEmployee: null,
          selectedDate: null,
          inTime: "",
          outTime: "",
          status: null,
        });
      } else {
        swal("Error", responseData.msg || "Failed to mark attendance", "error");
      }
    } catch (error) {
      console.error("Error marking attendance:", error);
      swal("Error", "An error occurred while marking attendance.", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const [showPreview, setShowPreview] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const filteredPreviewEmployees = filteredEmployees?.filter((employee) =>
    employee.employee_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <div  style={{ paddingTop: "17px" }}>
      <BulkAttendanceAdmin
        show={showcheckmodal}
        closeModal={closeModal}
        months={months}
      />
      <div
        className="d-flex justify-content-between align-items-center flex-wrap gap-2 px-3 py-3"
        style={{ background: "white" }}
      >
        <h5 className="mb-0">
          Attendance Management
        </h5>
        <div
          className="d-flex align-items-center flex-wrap gap-2"
        >
          <div
            className="color-box"
            style={{
              backgroundColor: "yellow",
              width: "20px",
              height: "20px",
              borderRadius: "4px",
            }}
          ></div>
          <div
            className="color-name d-flex align-items-center"
            style={{ fontSize: ".8rem" }}
          >
            Sunday / Second Saturday / Holiday
          </div>
          {selectedMonthHolidays.length > 0 && (
            <div
              aria-label="Holiday occasions for the selected month"
              style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginLeft: "12px" }}
            >
              {selectedMonthHolidays.map(([date, occasion]) => (
                <span
                  key={date}
                  style={{
                    backgroundColor: "#fff8a0",
                    color: "#554600",
                    borderRadius: "4px",
                    padding: "4px 8px",
                    fontSize: ".8rem",
                  }}
                >
                  {format(new Date(`${date}T00:00:00`), "dd MMM")}: {occasion}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
      <Form className="mx-2">
        <Row className="pt-0 pb-0">
          <Col>
            <Form.Group className="custom-form-group">
              <label>Select Employee</label>
              <Select
                options={employeeOptions}
                value={formData.selectedEmployee}
                onChange={(value) =>
                  handleInputChange("selectedEmployee", value)
                }
                placeholder="Select Employee"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999,
                  }),
                }}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="custom-form-group">
              <label>Status</label>
              <Select
                options={statusOptions}
                value={formData.status}
                onChange={(value) => handleInputChange("status", value)}
                placeholder="Select Status"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="custom-form-group">
              <label>Select Date</label>
              <Form.Control
                type="date"
                value={formData.selectedDate || ""}
                onChange={(e) =>
                  handleInputChange("selectedDate", e.target.value)
                }
                placeholder="Select a date"
                className="form-control"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="custom-form-group">
              <label>In Time</label>
              <Form.Control
                type="time"
                value={formData.inTime}
                onChange={(e) => handleInputChange("inTime", e.target.value)}
                placeholder="In Time"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="custom-form-group">
              <label>Out Time</label>
              <Form.Control
                type="time"
                value={formData.outTime}
                onChange={(e) => handleInputChange("outTime", e.target.value)}
                placeholder="Out Time"
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="pt-0 mt-2">
          <Col>
            <Button
              className="mx-1"
              variant="primary"
              size="sm"
              onClick={MarkAttendance}
            >
              Mark Attendance
            </Button>
            <Button
              className="mx-1"
              variant="secondary"
              size="sm"
              onClick={() => handleMarkAttendanceType("HalfDay")}
            >
              Mark Half Day
            </Button>
            <Button
              className="mx-1"
              variant="warning"
              size="sm"
              onClick={() => handleMarkAttendanceType("LATE")}
            >
              Mark Late
            </Button>
          </Col>
        </Row>
      </Form>
      <div className="m-2" style={{ background: "white" }}>
        <div className="row pb-0">
          <div className="col-md-10 col-12 p-0 d-flex align-items-center">
            <div className="px-md-2">
              <select
                value={years}
                style={{
                  width: "7rem",
                  height: "2rem",
                  borderRadius: ".4rem",
                  border: "1px #ced4da solid",
                }}
                onChange={(e) => setYears(e.target.value)}
              >
                <option value="" disabled>
                  Select Year
                </option>{" "}
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
              </select>
            </div>
            <div className="px-md-2">
              <select
                value={months}
                style={{
                  width: "7rem",
                  height: "2rem",
                  borderRadius: ".4rem",
                  border: "1px #ced4da solid",
                }}
                onChange={(e) => setMonths(e.target.value)}
              >
                <option value={2023}>Month</option>
                <option value={1}>January</option>
                <option value={2}>February</option>
                <option value={3}>March</option>
                <option value={4}>April</option>
                <option value={5}>May</option>
                <option value={6}>June</option>
                <option value={7}>July</option>
                <option value={8}>August</option>
                <option value={9}>September</option>
                <option value={10}>October</option>
                <option value={11}>November</option>
                <option value={12}>December</option>
              </select>
            </div>
            <div className=" px-md-2">
              <select
                style={{
                  width: "9rem",
                  height: "2rem",
                  borderRadius: ".4rem",
                  border: "1px #ced4da solid",
                }}
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
              >
                <option value="">All Department</option>
                {departmentData.map((dept) => (
                  <option key={dept.id} value={dept.cat1}>
                    {dept.cat1}
                  </option>
                ))}
              </select>
            </div>
            <div className=" px-md-2 ">
              {accessData &&
                accessData.map(
                  (module) =>
                    module.data &&
                    module.data.map((role) =>
                      role.role_name === "Attendance Check" ? (
                        role.access === "Y" ? (
                          <span key={role.pk_role_id}>
                            <button
                              style={{
                                height: "2rem",
                                borderRadius: ".4rem",
                                border: "1px #0074D9 solid",
                                fontSize: ".9rem",
                                background: "#fff",
                                color: "#0074D9",
                              }}
                              onClick={openModal}
                            >
                              Check Att.
                            </button>
                          </span>
                        ) : (
                          <span key={role.pk_role_id}>
                            <button
                              className="btn btn-sm btn-primary d-flex justify-content-center align-items-start"
                              style={{
                                color: "#fff",
                                height: "2rem",
                                border: "none",
                                borderRadius: ".4rem",
                                display: "flex",
                                fontSize: ".9rem",
                                backgroundColor: "gray",
                                cursor: "not-allowed",
                              }}
                              disabled
                            >
                              Check Att.
                            </button>
                          </span>
                        )
                      ) : null
                    )
                )}
            </div>
            <div className="px-2">
              <Button
                className="btn-sm btn btn-primary"
                onClick={() => setShowPreview(true)}
              >
                Preview
              </Button>
            </div>
            <div className="px-2">
              <Link to="/admin/Bulkexcelattendance">
                <Button
                  className="btn-sm"
                  style={{
                    cursor: "pointer",
                    border: "1px solid",
                    backgroundColor: "rgba(43, 193, 85, 0.1)",
                    color: "rgba(43, 193, 85, 1)",
                    bordercolor: "rgba(43, 193, 85, 1)",
                    borderRadius: ".4rem",
                  }}
                >
                  Bulk Attendance
                </Button>
              </Link>
            </div>
            <div className="px-2">
              {/* <Link to="/admin/raw-attendance">
              <Button
                className="btn-sm"
                style={{
                  cursor: "pointer",
                  border: "1px solid",
                  backgroundColor: "rgba(43, 193, 85, 0.1)",
                  color: "rgba(43, 193, 85, 1)",
                  bordercolor: "rgba(43, 193, 85, 1)",
                  borderRadius: ".4rem",
                }}
              >
            Raw Attendance
              </Button>
            </Link> */}
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <Link to="/admin/raw-attendance">
                  <Button
                    className="btn-sm"
                    style={{
                      cursor: "pointer",
                      border: "1px solid rgba(43, 193, 85, 1)",
                      backgroundColor: "rgba(43, 193, 85, 0.1)",
                      color: "rgba(43, 193, 85, 1)",
                      borderRadius: ".4rem",
                      padding: "4px 10px",
                    }}
                  >
                    Raw Attendance
                  </Button>
                </Link>
                <img
                  src={gifIcon}
                  alt="icon"
                  style={{ width: "4rem" }} // adjust size
                />
              </div>
            </div>
          </div>
          <div className="col d-flex justify-content-end  align-items-center ">
            <div>
              <Button
                className="btn-sm btn btn-success"
                onClick={handleMarkAttendance}
              >
                Save Attendance
              </Button>
            </div>
          </div>
        </div>

        <div
          style={{ overflowX: "auto", width: "100%", scrollbarWidth: "auto" }}
        >
          <div
            style={{
              maxHeight: "70vh",
              overflow: "auto",
              scrollbarWidth: "auto",
            }}
          >
            <table
              className="m-2 table table-bordered"
              style={{ borderCollapse: "collapse", width: "100%" }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      position: "sticky",
                      top: 0,
                      background: "#48A6A7",
                      zIndex: 2,
                      textAlign: "center",
                      color: "#fff",
                    }}
                  >
                    Employee{" "}
                  </th>

                  {tableHeaders}
                </tr>
              </thead>
              <tbody>
                {filteredEmployees.map((employee) => (
                  <tr key={employee.id}>
                    <td style={{ fontSize: ".8rem" }}>
                      {employee.employee_name}
                    </td>
                    {dates.map((date, i) => (
                      <td
                        className="p-0"
                        key={i}
                        style={{
                          backgroundColor: isSunday(date) || isSecondSaturday(date) || holidayDates[format(date, "yyyy-MM-dd")] ? "#fff8a0" : "white",
                          border: "1px solid #ced4da",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            flexDirection: "column",
                          }}
                        >
                          {/* Checkboxes for attendance */}
                          {accessData &&
                            accessData.map((module) =>
                              module.data?.map((role) =>
                                role.role_name === "Add Attendance" &&
                                role.access === "Y" ? (
                                  <span
                                    key={role.pk_role_id}
                                    style={{ marginLeft: "10px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      style={{ margin: 0 }}
                                      checked={employee.data.some(
                                        (entry) =>
                                          format(
                                            new Date(entry.attendance_date),
                                            "yyyy-MM-dd"
                                          ) === format(date, "yyyy-MM-dd") &&
                                          entry.attendance_status === "Y"
                                      )}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          employee.employee_code,
                                          date,
                                          e.target.checked
                                        )
                                      }
                                    />
                                  </span>
                                ) : null
                              )
                            )}

                          {/* WFH, SL, PL, HalfDay Icons */}
                          {employee.data.some(
                            (entry) =>
                              format(
                                new Date(entry.attendance_date),
                                "yyyy-MM-dd"
                              ) === format(date, "yyyy-MM-dd") &&
                              entry.type === "WFH"
                          ) && (
                            <span style={{ marginLeft: "5px", color: "green" }}>
                              <FaHome />
                            </span>
                          )}

                          {employee.data.some(
                            (entry) =>
                              format(
                                new Date(entry.attendance_date),
                                "yyyy-MM-dd"
                              ) === format(date, "yyyy-MM-dd") &&
                              entry.type === "SL"
                          ) && (
                            <span
                              style={{
                                marginLeft: "5px",
                                color: "red",
                                fontSize: ".8rem",
                              }}
                            >
                              <b>SL</b>
                            </span>
                          )}

                          {employee.data.some(
                            (entry) =>
                              format(
                                new Date(entry.attendance_date),
                                "yyyy-MM-dd"
                              ) === format(date, "yyyy-MM-dd") &&
                              entry.type === "PL"
                          ) && (
                            <span
                              style={{
                                marginLeft: "5px",
                                color: "blue",
                                fontSize: ".8rem",
                              }}
                            >
                              <b>PL</b>
                            </span>
                          )}

                          {employee.data.some(
                            (entry) =>
                              format(
                                new Date(entry.attendance_date),
                                "yyyy-MM-dd"
                              ) === format(date, "yyyy-MM-dd") &&
                              entry.type === "HalfDay"
                          ) && (
                            <span
                              style={{ marginLeft: "10px", color: "green" }}
                            >
                              <img
                                src={halfday}
                                style={{ width: "auto", height: "4vh" }}
                              />
                            </span>
                          )}

                          {/* ✅ Display all time entries for the date */}
                          {employee.data
                            .filter(
                              (entry) =>
                                format(
                                  new Date(entry.attendance_date),
                                  "yyyy-MM-dd"
                                ) === format(date, "yyyy-MM-dd")
                            )
                            .map((entry, idx) => (
                              <div
                                key={idx}
                                className="m-1"
                                style={{
                                  backgroundColor:
                                    entry.type === "LATE"
                                      ? "#ffe5e5"
                                      : "#f5f5f5",
                                  border: "1px solid #ccc",
                                  borderRadius: "6px",
                                  padding: "2px 6px",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  fontSize: "0.7rem",
                                  minWidth: "55px",
                                }}
                              >
                                {entry.type === "LATE" && (
                                  <MdWatchOff
                                    style={{
                                      color: "#d9534f",
                                      fontSize: "1.2rem",
                                      marginBottom: "2px",
                                    }}
                                  />
                                )}
                                <span
                                  style={{ color: "#000", fontWeight: 500 }}
                                >
                                  {entry.in_time || "-"}
                                </span>
                                <span
                                  style={{ color: "#000", fontWeight: 500 }}
                                >
                                  {entry.out_time || "-"}
                                </span>
                              </div>
                            ))}
                        </div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {showPreview && (
        <Modal
          show={showPreview}
          onHide={() => setShowPreview(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "1.2rem" }}>
              Attendance Preview
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Search Input */}
            <Form.Group className="mb-2">
              <Form.Control
                type="text"
                placeholder="Search Employee..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ width: "20vw" }}
              />
            </Form.Group>

            <div
              style={{
                maxHeight: "70vh",
                overflowY: "auto",
                overflowX: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              <table className="table table-bordered">
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "white",
                    zIndex: 2,
                  }}
                >
                  <tr>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Employee
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Total Present
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Total Absent
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      SL Balance
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      PL Balance
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Total used PL
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Total used SL
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Total WFH
                    </th>
                    <th style={{ fontSize: ".8rem", fontWeight: "400" }}>
                      Total HalfDay
                    </th>
                    {tableHeaders}
                  </tr>
                </thead>
                <tbody>
                  {filteredPreviewEmployees.map((employee) => {
                    const totalPresent = employee.data.filter(
                      (entry) => entry.attendance_status === "Y"
                    ).length;
                    const totalAbsent = dates.length - totalPresent;

                    const totalPL = employee.data.filter(
                      (entry) => entry.type === "PL"
                    ).length;

                    const totalSL = employee.data.filter(
                      (entry) => entry.type === "SL"
                    ).length;

                    const totalWFH = employee.data.filter(
                      (entry) => entry.type === "WFH"
                    ).length;

                    const totalHalfday = employee.data.filter(
                      (entry) => entry.type === "HalfDay"
                    ).length;

                    return (
                      <tr key={employee.id}>
                        <td style={{ fontSize: ".9rem", fontWeight: "400" }}>
                          {employee.employee_name}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "green",
                          }}
                        >
                          {totalPresent}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "red",
                          }}
                        >
                          {totalAbsent}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "green",
                          }}
                        >
                          {employee.sl_bal}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "green",
                          }}
                        >
                          {employee.pl_bal}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "blue",
                          }}
                        >
                          {totalPL}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "orange",
                          }}
                        >
                          {totalSL}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "purple",
                          }}
                        >
                          {totalWFH}
                        </td>
                        <td
                          style={{
                            fontWeight: "bold",
                            fontSize: ".9rem",
                            fontWeight: "400",
                            color: "purple",
                          }}
                        >
                          {totalHalfday}
                        </td>
                        {dates.map((date, i) => (
                          <td key={i} style={{ textAlign: "center" }}>
                            {employee.data.some(
                              (entry) =>
                                format(
                                  new Date(entry.attendance_date),
                                  "yyyy-MM-dd"
                                ) === format(date, "yyyy-MM-dd") &&
                                entry.attendance_status === "Y"
                            )
                              ? "✔️"
                              : "❌"}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};
export default AttandancecalendraAdmin;
